export default __webpack_public_path__ + "static/media/yellow-star.10edf237.png";